import * as CONSTANTS from "../../constants";
import { getTag, getCategoryID, getTagValue } from "../../utils";
import { padSelectedTags } from "./myLearningFilterUrl";

export const computeTagSlotLength = (tags, latestFilter) =>
  Math.max(
    tags?.length || 0,
    latestFilter.selectedTags?.length || CONSTANTS.FILTER_INITIAL_TAGS.length,
  );

export const alignParsedTagsWithDefinitions = (selectedTags, tags) => {
  if (!tags || tags.length === 0) {
    return selectedTags;
  }
  return selectedTags.map((vid, i) => {
    if (!vid) {
      return 0;
    }
    const tagDef = tags[i];
    if (!tagDef || !Array.isArray(tagDef.values)) {
      return 0;
    }
    return tagDef.values.some((v) => v.valueId === vid) ? vid : 0;
  });
};

export const resolveCategoryIdForHydration = (parsedCategoryId, categories) => {
  let categoryId = parsedCategoryId || 0;
  if (categoryId && categories && !categories[categoryId]) {
    categoryId = 0;
  }
  return categoryId;
};

export const buildPaddedSelectedTags = (
  parsedSelectedTags,
  tags,
  latestFilter,
) => {
  const tagLen = computeTagSlotLength(tags, latestFilter);
  let selectedTags = padSelectedTags(parsedSelectedTags, tagLen);
  if (tags && tags.length > 0) {
    selectedTags = alignParsedTagsWithDefinitions(selectedTags, tags);
  }
  return selectedTags;
};

/**
 * Legacy hash query keys from tenant setting `mycoursesfiltertags`.
 */
export const applyLegacyMycoursesFilterTagsFromHash = ({
  tagsList,
  tags,
  categories,
  queryParams,
  updateState,
  setTagFilter,
}) => {
  tagsList.forEach((tag) => {
    const tagValue = queryParams.get(tag);
    if (!tagValue) {
      return;
    }

    if (tag === "category") {
      const categoryId = getCategoryID(tagValue, categories);
      updateState((prevState) => ({
        ...prevState,
        filter: { ...prevState.filter, categoryId },
      }));
    } else {
      const tagData = getTag(tag, tags);
      const valueId = getTagValue(tagData, tagValue);
      if (valueId != null) {
        setTagFilter(0, valueId);
      }
    }
  });
};
